import axiosClient from "../axiosClient";
import { CheckNullParams } from "../../utils/CheckNullParams";
const categoryApi = {
  getCategories: (params) => {
    const url = "blog-category";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },
  createCategory: (params) => {
    const url = "blog-category";
    const payload = CheckNullParams(params);

    return axiosClient.post(url, payload);
  },
  updateCategory: (id, params) => {
    const url = "blog-category/";
    // const payload = CheckNullParams(params);
    return axiosClient.patch(url + id, params);
  },
  deleteCategory: (id) => {
    const url = "blog-category/";
    return axiosClient.delete(url + id);
  },
  deleteCategorys: (params) => {
    const url = "blog-category";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default categoryApi;
